import { render, staticRenderFns } from "./VvValid.vue?vue&type=template&id=b57c20a6&scoped=true&"
import script from "./VvValid.vue?vue&type=script&lang=js&"
export * from "./VvValid.vue?vue&type=script&lang=js&"
import style0 from "./VvValid.vue?vue&type=style&index=0&id=b57c20a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57c20a6",
  null
  
)

export default component.exports